import { render, staticRenderFns } from "./SubscriptionsPrices.vue?vue&type=template&id=7b8b7267&scoped=true"
import script from "./SubscriptionsPrices.vue?vue&type=script&lang=js"
export * from "./SubscriptionsPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b7267",
  null
  
)

export default component.exports